import {
  HStack,
  Flex,
} from '@chakra-ui/react';
import { ColorModeButton } from '../common/color-mode';
import { NavLink } from 'react-router-dom';
import { LogoMarkLink } from '../icons/Logo';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routeTo } from '@/router/routeTo';

export const AuthHeader = () => {
  const { t } = useTranslation(['common']);

  const location = useLocation();
  const pathname = location.pathname;

  return (
    <Flex
      as="header"
      w="full"
      align="center"
      justify="space-between"
      borderBottom="1px solid"
      px={6}
      py={4}
      position="relative"
      zIndex={10}
    >
      {/* Logo & Brand */}
      <LogoMarkLink />

      {/* Navigation + Theme Toggle */}
      <HStack gap={4}>
        {pathname !== routeTo.signIn() && (
          <NavLink to={routeTo.signIn()}>{t('nav.signIn')}</NavLink>
        )}
        {pathname !== routeTo.signUp() && (
          <NavLink to={routeTo.signUp()}>{t('nav.signUp')}</NavLink>
        )}
        <ColorModeButton />
      </HStack>
    </Flex>
  );
};